import React from 'react';
import styled from 'styled-components';
import { FaMagic, FaChartBar, FaUserShield } from 'react-icons/fa';
import { designTokens } from '../foundation/DesignTokens';
import { Drawer, DrawerList, DrawerItem } from './Drawer';

// Styled sidebar title
const SidebarTitle = styled.div`
  font-family: ${designTokens.fonts.heading};
  font-weight: 800;
  font-size: 1.25rem;
  color: ${designTokens.colors.gray[900]};
  margin-bottom: ${designTokens.spacing.xl};
  padding-left: 12px;
  display: flex;
  align-items: center;
  gap: ${designTokens.spacing.sm};

  @media (max-width: 900px) {
    font-size: 1.1rem;
    margin-bottom: ${designTokens.spacing.lg};
  }
`;

// Enhanced drawer item with better styling
const NavItem = styled(DrawerItem)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: ${designTokens.radius.md};
  color: ${designTokens.colors.gray[700]};
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  margin-bottom: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  width: 100%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: ${designTokens.colors.gray[50]};
    color: ${designTokens.colors.gray[900]};
  }

  ${(props) =>
    props.active &&
    `
    background-color: ${designTokens.colors.primary[50]};
    color: ${designTokens.colors.primary[600]};
    font-weight: 600;
    border-color: ${designTokens.colors.primary[100]};
  `}

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}

  @media (max-width: 900px) {
    font-size: 0.87rem;
    padding: 10px 14px;
    gap: 10px;
  }
`;

// Icon wrapper
const NavIcon = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.active ? 1 : 0.7)};
  transition: opacity 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: 900px) {
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

// Navigation items configuration for Dashboard/Statistics
const navigationItems = [
  {
    id: 'iventas-ai',
    label: 'iVentas AI',
    Icon: FaMagic,
    scrollTarget: null, // Scrolls to top
  },
  {
    id: 'resumen-general',
    label: 'Resumen General',
    Icon: FaChartBar,
    scrollTarget: 'resumen-general',
    disabled: true, // TODO: Habilitar cuando la API devuelva datos estructurados
  },
  {
    id: 'rendimiento-agentes',
    label: 'Rendimiento Agentes',
    Icon: FaUserShield,
    scrollTarget: 'rendimiento-agentes',
    disabled: true, // TODO: Habilitar cuando la API devuelva datos estructurados
  },
];

const DashboardNavigation = ({ activeView, onViewChange }) => {
  const handleNavClick = (item) => {
    if (item.disabled) return;

    // Update active view
    onViewChange(item.id);

    // Scroll to section
    if (item.scrollTarget) {
      const element = document.getElementById(item.scrollTarget);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Scroll to top for iventas-ai
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Drawer>
      <SidebarTitle>Estadísticas</SidebarTitle>

      <DrawerList>
        {navigationItems.map((item) => (
          <NavItem
            key={item.id}
            active={activeView === item.id}
            disabled={item.disabled}
            onClick={() => handleNavClick(item)}>
            <NavIcon active={activeView === item.id}><item.Icon /></NavIcon>
            {item.label}
          </NavItem>
        ))}
      </DrawerList>
    </Drawer>
  );
};

export default DashboardNavigation;
